import { lazy } from 'react';

export const AsyncAIFeedbackFlag: import("react").LazyExoticComponent<({ displayFlag, onDismissed, description, title, actions, }: {
    displayFlag: boolean;
    onDismissed: () => void;
    description: string;
    title: string;
    actions?: import("@atlaskit/flag").ActionsType;
}) => React.JSX.Element> = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_search-ai-feedback-flag" */ './ai-feedback-flags'
	).then(({ AIFeedbackFlag }) => ({ default: AIFeedbackFlag })),
);
